import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UEditTextComponent } from './u-edit-text.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [UEditTextComponent],
  imports: [CommonModule, FormsModule],
  exports: [UEditTextComponent],
})
export class UEditTextModule {}
